/**
 * Help Button Component
 *
 * A (?) icon button placed in each page header that replays the
 * current page's walkthrough tour when clicked.
 */

import { HelpCircle } from 'lucide-react';

interface HelpButtonProps {
  onClick: () => void;
  className?: string;
}

export function HelpButton({ onClick, className = '' }: HelpButtonProps) {
  return (
    <button
      onClick={onClick}
      className={`inline-flex items-center justify-center rounded-lg p-1.5 text-gray-400 transition-colors hover:bg-gray-100 hover:text-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 ${className}`}
      aria-label="Page walkthrough help"
      title="Show page walkthrough"
    >
      <HelpCircle size={20} />
    </button>
  );
}
